import React, { useState } from 'react';
import { Card, Container, Form, Button, Spinner } from 'react-bootstrap';
import axios from 'axios';
import ExcelJS from 'exceljs';
import { BASE_URL } from '../../components/APi';
import Navbar from '../../components/Navbar';
import Sidebar from '../../components/Sidebar';
import { baseexcel } from '../../Files/Subjects/Baseurl';

const Sortdateresult = () => {

  const additionalMessage = "For each area of your life with respect to Physical Health & Mental Health, answer the questions necessary out of the four questions below.";
  const education = "For each area of your life with respect to Work & Education, answer the questions necessary out of the four questions below.";
  const wealth = "For each area of your life with respect to Wealth, answer the questions necessary out of the four questions below.";
  const self = "For each area of your life with respect to Self Awareness, answer the questions necessary out of the four questions below.";


  // const workEducationLabels = [
  //   'education', 'job', 'Business', 'profession', 'knowledge', 'earnings',
  //   'competencies'
  //   , 'skills', 'leadership', 'teamSkills', 'transport',
  //   'lifestyleWork', 'goalsInWork'
  // ];
const workEducationLabels = [
  'education', 'job', 'Business', 'profession', 'knowledge', 'earnings',
  'competencies', 'skills', 'leadership', 'teamSkills', 'transport',
  'lifestyleWork', 'goalsInWork'
];
  const wealthLabels = [
    'income', 'savings', 'property', 'inheritance', 'assets', 'growth', 'expansion', 'personalgadgets', 'personalfinance', 'budgeting', 'planning', 'lifestyle', 'subscription', 'taxes', 'housing', 'liabilities', 'loans', 'luxuryandcomfort', 'technology', 'goals In Wealth',
  ];

  const selfAwarenessTopics = [
    "prayers", "discipline", "meditation", "reading", "music", "fashion",
    "travel", "reflecting", "creation", "confidence", "values",
    "learnings", "miracles", "spirituality", "devotion", "dreams",
    "future", "goalsInSelfAwareness"
  ];

 
  const customerFields = [
    "startdate", "enddate", "fullname", "age", "gender", "maritalstatus", "occupation",
    "address", "city", "state", "country", "contactnumber", "emailid","examstartdate","starttime","endtime","couponname","paymentamount"
  ];
  const questionSuffixes = [
    " - IS THIS AREA APPLICABLE FOR YOU?",
    " - IS THIS AREA WORKING FOR YOU?",
    " - HOW CRITICAL IS THIS AREA FOR YOU?",
    " - HOW DO YOU SEE YOUR FUTURE IN THIS AREA?"
  ];



  const [loading, setLoading] = useState(false);
const relationshipLabels = [
    'Mother', 'Father', 'Children', 'Grandparents', 'Partner', 'Spouse',
    'Siblings', 'Girlfriends', 'Boyfriends', 'Friends', 'friendswithbenefits',
    'Relatives', 'Communities', 'Boss', 'Colleague', 'Teacher', 'Classmate',
    'Conflicts', 'Love', 'Intimacy', 'Sex', 'Commitments', 'goalsinrelationship'
  ];

  const healthLabels = [
    'weight', 'Fitness', 'Vitality', 'Power', 'Diseases', 'Nutrition', 'Diet', 'Cooking', 'Hygiene', 'personalcare', 'Sports', 'Entertainment', 'Emotion',
    'Traumas', 'Stress', 'Vacation', 'lifestyleinhealth', 'goalsinhealth', ,


  ];

 

function generateDynamicHeaders(label) {
  const questionSuffixes = [
    ' - IS THIS AREA APPLICABLE FOR YOU?',
    ' - IS THIS AREA WORKING FOR YOU?',
    ' - HOW CRITICAL IS THIS AREA FOR YOU?',
    ' - HOW DO YOU SEE YOUR FUTURE IN THIS AREA?'
  ];
  return questionSuffixes.map(suffix => label.toUpperCase() + suffix);
}

 
const handleDownload = async (startDate, endDate) => {
  setLoading(true);
 
  const routes = [
    `${baseexcel}excel/getcu/${startDate}/${endDate}`,
    `${baseexcel}excel/get/${startDate}/${endDate}`,
    `${baseexcel}excel/get1/${startDate}/${endDate}`,
    `${baseexcel}excel/get2/${startDate}/${endDate}`,
    `${baseexcel}excel/get3/${startDate}/${endDate}`,
    `${baseexcel}excel/get4/${startDate}/${endDate}`,
    `${baseexcel}excel/get5/${startDate}/${endDate}`,
    `${baseexcel}excel/get6/${startDate}/${endDate}`,
    `${baseexcel}excel/get7/${startDate}/${endDate}`,
    `${baseexcel}excel/get8/${startDate}/${endDate}`,
    `${baseexcel}excel/get9/${startDate}/${endDate}`,
    `${baseexcel}excel/get10/${startDate}/${endDate}`,
    `${baseexcel}excel/get11/${startDate}/${endDate}`,
    `${baseexcel}excel/get12/${startDate}/${endDate}`,
    `${baseexcel}excel/get13/${startDate}/${endDate}`,
  ];

  try {
    const resArr = await Promise.all(routes.map(url => axios.get(url)));
    const [
      customerRes, rel1, rel2, rel3, rel4, health, nutrition, emotion, workeducation,
      wealth1, wealth2, wealth3, self1, self2, self3
    ] = resArr.map(r => r.data);

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Full Export");

    const relationshipData = rel1.map((item, i) => ({
      ...item,
      ...rel2[i],
      ...rel3[i],
      ...rel4[i],
      ...health[i],
      ...nutrition[i],
      ...emotion[i],
      ...workeducation[i],
      ...wealth1[i],
      ...wealth2[i],
      ...wealth3[i],
      ...self1[i],
      ...self2[i],
      ...self3[i],
    }));

    const customerHeaders = customerFields.map(f => f.toUpperCase());
    const allRelKeys = Object.keys(relationshipData[0] || {});
    const orderedRelKeys = [];
    const relationshipHeaders = [];

    const allLabels = [
      ...relationshipLabels,
      ...healthLabels.filter(Boolean),
      ...workEducationLabels,
      ...wealthLabels,
      ...selfAwarenessTopics,
    ];

    allLabels.forEach(label => {
      const lowerLabel = label.toLowerCase().replace(/\s/g, "");
      let keys = allRelKeys
        .filter(k => new RegExp(`^${lowerLabel}\d*$`).test(k.toLowerCase()))
        .sort((a, b) => {
          const numA = parseInt(a.slice(lowerLabel.length)) || 0;
          const numB = parseInt(b.slice(lowerLabel.length)) || 0;
          return numA - numB;
        });

      if (keys.length === 0) {
        keys = [1, 2, 3, 4].map(n => `${lowerLabel}${n}`);
      }

      const dynHeaders = generateDynamicHeaders(label);
      keys.forEach((key, idx) => {
        orderedRelKeys.push(key);
        relationshipHeaders.push(dynHeaders[idx] || key.toUpperCase());
      });
    });

    let colStart = 1;
    const setHeading = (label, count, color = 'FF4BACC6') => {
      const start = colStart;
      const end = colStart + count - 1;
      worksheet.mergeCells(1, start, 1, end);
      for (let i = start; i <= end; i++) {
        const cell = worksheet.getCell(1, i);
        if (i === start) cell.value = label;
        cell.font = { bold: true, size: 16, color: { argb: 'FFFFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: color } };
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        cell.border = {
          top: { style: 'medium' }, left: { style: 'medium' },
          bottom: { style: 'medium' }, right: { style: 'medium' }
        };
      }
      worksheet.getRow(1).height = 30;
      colStart = end + 1;
    };

    const relLabelCount = relationshipLabels.length * 4;
    const healthLabelCount = healthLabels.filter(Boolean).length * 4;
    const workEduLabelCount = workEducationLabels.length * 4;
    const wealthLabelCount = wealthLabels.length * 4;
    const selfAwarenessLabelCount = selfAwarenessTopics.length * 4;

    setHeading("CUSTOMER DETAILS", customerHeaders.length, 'B1A0C7');
    setHeading("RELATIONSHIPS", relLabelCount, '4481c5');
    setHeading("HEALTH", healthLabelCount, 'FFBD16');
    setHeading("WORK & EDUCATION", workEduLabelCount, 'f90945');
    setHeading("WEALTH", wealthLabelCount, '45b43b');
    setHeading("SELF AWARENESS", selfAwarenessLabelCount, '3d3d3d');

    let colIndex = 1;
    const writeHeaders = headers => headers.forEach(h => {
      const cell = worksheet.getCell(2, colIndex++);
      cell.value = h;
      cell.font = { bold: true, color: { argb: 'FF000000' } };
      cell.fill = {
        type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFDBE5F1' }
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      cell.border = {
        top: { style: 'thin' }, left: { style: 'thin' },
        bottom: { style: 'thin' }, right: { style: 'thin' }
      };
    });

    writeHeaders(customerHeaders);
    writeHeaders(relationshipHeaders);

    worksheet.views = [{ state: 'frozen', ySplit: 2 }];

    for (let i = 0; i < customerRes.length; i++) {
      const row = worksheet.getRow(i + 3);
      const isEven = i % 2 === 0;
      let col = 1;

      const writeData = (obj, keys) => {
        keys.forEach(key => {
          const cell = row.getCell(col++);
          cell.value = obj?.[key] ?? "";
          cell.alignment = { vertical: 'top', horizontal: 'left' };
          cell.border = {
            top: { style: 'thin' }, bottom: { style: 'thin' },
            left: { style: 'thin' }, right: { style: 'thin' },
          };
          if (isEven) {
            cell.fill = {
              type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2F2F2' },
            };
          }
        });
      };

      writeData(customerRes[i], customerFields);
      writeData(relationshipData[i], orderedRelKeys);
    }

    worksheet.columns.forEach(col => {
      let maxLength = 10;
      col.eachCell({ includeEmpty: true }, cell => {
        const value = cell.value ? cell.value.toString() : '';
        maxLength = Math.max(maxLength, value.length);
      });
      col.width = maxLength + 2;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Full_Report_${startDate}_to_${endDate}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Download failed:", error);
  } finally {
    setLoading(false);
  }
};


 

  const handleSubmit = (e) => {
    e.preventDefault();
    const startDate = e.target.startDate.value;
    const endDate = e.target.endDate.value;

    handleDownload(startDate, endDate, setLoading);
  };

  return (
       <Card>
        <Card.Header as="h5">Export Result to Excel</Card.Header>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col">
                <Form.Group controlId="formStartDate">
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control type="date" name="startDate" required />
                </Form.Group>
              </div>
              <div className="col">
                <Form.Group controlId="formEndDate">
                  <Form.Label>End Date</Form.Label>
                  <Form.Control type="date" name="endDate" required />
                </Form.Group>
              </div>
            </div>
            <br />
            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />{" "}
                  Generating Excel...
                </>
              ) : (
                "Download Excel"
              )}
            </Button>
          </Form>
        </Card.Body>
      </Card>
   );
};

export default Sortdateresult;
